/**
 * 随机从数组中获取指定长度的元素
 * @param array 数组
 * @param length 需要获取的随机长度
 * @returns 长度为length的随机数组
 */
export function getRandomItems(array: any[], length: number) {
  if (!array || !array.length) {
    return [];
  }
  const result: any[] = [];
  const tempSet = new Set();

  while (result.length < length) {
    const randomIndex = Math.floor(Math.random() * array.length);
    const item = array[randomIndex];

    if (!tempSet.has(item)) {
      tempSet.add(item);
      result.push(item);
    }
  }

  return result;
}
